/* unplugin-vue-components disabled */import script from "./WORolesWithOrganizations.vue?vue&type=script&setup=true&lang=js"
export * from "./WORolesWithOrganizations.vue?vue&type=script&setup=true&lang=js"

import "./WORolesWithOrganizations.vue?vue&type=style&index=0&id=72e1a1a0&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e1a1a0"]])

export default __exports__